/* Header: the logo shrinks a little once the page has scrolled. Only a transform changes, so nothing around it moves. */
(() => {
  let ticking = false;
  const apply = () => {
    ticking = false;
    document.documentElement.classList.toggle('cv-scrolled', (window.pageYOffset || document.documentElement.scrollTop) > 24);
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(apply); }
  }, { passive: true });
  apply();
})();
